import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppContext } from '../AppContext';
import { isMediaRecorderSupported } from '../AppUtils';
import { isIOS } from '../AppUtils';

//import {saveAs} from 'file-saver';

class Step1IMG extends React.Component {

    constructor(props) {
        super(props);


        this.number = this.number.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    componentDidMount() {

        if (!isMediaRecorderSupported || isIOS) {
            document.getElementById("imageUpload").className = "hidden";
            document.getElementById("unsupportedNext").classList.remove("hidden");
        }
    }

    number() {
        var charCount = document.querySelector('.character-cont');
        var textInput = document.querySelector('.text_input');
        document.getElementById('unsupportedNext').classList.remove("unclickable");
        if (textInput) {
            charCount.innerHTML = 30 - textInput.value.length;
        }
    }

    submitForm() {

        var self = this;
        
        var userMessage = document.getElementById("userMessage").value;
        self.context.message = userMessage;
        self.props.history.push('step2img');                
    }

    render() {

        return (
            <div>
                <img src="img/texture1.png" className="backgroundfill" alt=""/>
                <div className="side-menu ">
                    <div className="cover"></div>
                    <div className="step-menu-con">
                        <img src="img/sid-menu-img.png" alt="example gif" srcSet="" className="side-menu-top"/>
                        <div className="center-gold"></div>
                        <h1>thank you lord</h1>
                        <h3>enhanced video</h3>

                        <div className="textcon">
                            <p>Join Chris Tomlin, Thomas Rhett, and Florida Georgia Line in a :25 clip from “Thank You Lord”!</p>
                            <div className="center-gold"></div>
                        </div>

                        <div className="listcon">
                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber">1</div>
                                </div>
                                <h2 className="step-title">tell us what you’re thankful for</h2>
                            </div>

                            <div className="con">
                                <div className="step">
                                    <div className="stepnumber">2</div>
                                </div>
                                <h2 className="step-title"> Show what you are thankful for</h2>
                            </div>

                            <div className="con">
                                <div className="step">
                                    <div className="stepnumber">3</div>
                                </div>
                                <h2 className="step-title"> get your custom music video!</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="body-con ">
                    <br/>                    

                    <div id='step1'>
                        <div className="current-step">
                            <div className="line-before"></div>
                            <div className="con step-con">
                                <div className="step">
                                    <div className="stepnumber">1</div>
                                </div>
                            </div>
                            <div className="line-after"></div>
                        </div>
                        <h1 className="main-color">what are you < br className="deskhidden" />thankful for?</h1>

                        <div className="textcon">
                            <p>It could be your family, your best friend, <br/> your dog, or just being in good health.</p>
                        </div>

                        <div className="input-con thankful">
                            <input id="userMessage" type="text" placeholder="start typing" onKeyUp={this.number} required className="text_input" maxLength="30"/>

                            <label className="label-name">
                                <span className="content-name">
                                    <h3>i’m thankful for</h3> 
                                </span>
                            </label>
                            <div className="input_line"></div>
                            <div className="character-cont"> 30 </div>

                        </div>
                        <div id="unsupportedNext" className="next-button-con  next unclickable" onClick={this.submitForm}
                                data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:GotoStep2'>
                            <div className="line-before"></div>
                            <div className="next-button">
                                <div className="nexr-button-innercon">
                                    <div className="next-button-text">Next</div>
                                    <div className="next-button-arrow"><img src="img/arrow-right.svg" alt=""/></div>
                                </div>
                            </div>
                            <div className="line-after"></div>
                        </div>
                        <div id="imageUpload" className="hidden">
                            <div className="textcon">
                                <p> And what does that look like to you?</p>
                            </div>

                            <div id="item" className="hidden"></div>
                            

                            <div className="flex-con">
                            <div id="rotate"  className="hidden next-button-con inline-but small " onClick={this.rotateImg} 
                                data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:RotateImg'>
                                <div className="next-button">
                                    <div className="nexr-button-innercon">
                                        
                                        <div className="next-button-text file1-text"> rotate image</div>
                                    </div>
                                </div>
                            </div>
                            <div className="next-button-con inline-but">
                            <label htmlFor="file-1" >
                                <div className="next-button">
                                    <div className="nexr-button-innercon">
                                        <input type="file" name="file-1[]" id="file-1" onChange={this.showFile} className="inputfile inputfile-1" accept="image/*" 
                                        data-amplify-analytics-on='click'
                                        data-amplify-analytics-name='click'
                                        data-amplify-analytics-attrs='attr:UploadImg'/>
                                        <label htmlFor="file-1" className="next-button-text file1-text"> Choose a file&hellip;</label>
                                    </div>
                                </div>
                                </label>
                            </div>

                       

                            </div>  
                            <br/>

                            <div className="next-button-con hidden next" onClick={this.submitForm}
                                data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:GotoStep2'>
                                <div className="line-before"></div>
                                <div className="next-button">
                                    <div className="nexr-button-innercon">
                                        <div className="next-button-text">listen to the song</div>
                                        <div className="next-button-arrow"><img src="img/arrow-right.svg" alt=""/></div>
                                    </div>
                                </div>
                                <div className="line-after"></div>
                            </div>
                        </div>
                      
                    </div>
                </div>

            </div>
        );
    }
}

Step1IMG.contextType = AppContext;
export default withRouter(Step1IMG);